import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Text,
  Spinner,
} from "@chakra-ui/react";
import StarRatings from "react-star-ratings";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { submitPoliticianFeedback } from "../redux/actions/data/DataActions";
import { RootStore } from "../redux/Store";

function AddReviewModal(props: any) {
  const [regClickState, setregClickState] = useState(false);

  const [revData, setRevData] =
    useState<{ review?: string; rating?: number }>();
  const uiState = useSelector((state: RootStore) => state.ui);

  const validation = (): boolean => {
    let isValid = true;

    if (!revData?.review || !revData?.rating) {
      isValid = false;
    }

    return isValid;
  };
  const dispatch = useDispatch();
  const handleReviewSubmit = () => {
    setregClickState(true);
    if (validation()) {
      const reviewData = {
        review: revData?.review,
        rating: revData?.rating,
      };
      dispatch(props.submitFeedbackFunc(props._id, reviewData));
    }
  };
  useEffect(() => {
    if (uiState.loading === false) {
      setRevData({ review: "", rating: 0 });
      props.onClose();
    }
  }, [uiState.loading]);
  function changeRating(newRating: number) {
    setRevData({
      ...revData,
      rating: newRating,
    });
  }
  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={props.isOpen}
        onClose={props.onClose}
        isCentered
        motionPreset="slideInBottom"
        colorScheme="blue"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Review</ModalHeader>
          {/* <ModalCloseButton /> */}
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Review</FormLabel>
              <Textarea
                isInvalid={regClickState ? !revData?.review && true : false}
                id="reviewTextField"
                placeholder="Write your review"
                name="review"
                value={revData?.review}
                onChange={(event) =>
                  setRevData({
                    ...revData,
                    review: event.target.value,
                  })
                }
              />
              {regClickState && !revData?.review && (
                <Text fontSize="xs" color="red" marginTop="3px">
                  {"Review must not be empty"}
                </Text>
              )}
            </FormControl>
            <FormControl mt={4}>
              <FormLabel>Rating</FormLabel>
              <StarRatings
                isInvalid={regClickState ? !revData?.rating && true : false}
                starDimension="35px"
                id="ratingField"
                starSpacing="0px"
                starRatedColor="green"
                numberOfStars={5}
                name="rating"
                rating={revData?.rating}
                changeRating={changeRating}
              />
              {regClickState && !revData?.rating && (
                <Text fontSize="xs" color="red" marginTop="3px">
                  {"Click in the stars to give ratings"}
                </Text>
              )}
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              id="addReview"
              isLoading={uiState.loading}
              loadingText={"Adding Review"}
              disabled={uiState.loading}
              onClick={handleReviewSubmit}
              colorScheme="blue"
              mr={3}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              Add Review
            </Button>
            <Button
              onClick={props.onClose}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AddReviewModal;
